import COPY from "./content/siteCopy.json";
import { useEffect, useState } from "react";

export const API = process.env.REACT_APP_BACKEND_URL;

let cache = null;
export function usePlaybooks() {
  const [list, setList] = useState(cache);
  useEffect(() => {
    if (cache) return;
    fetch(`${API}/api/public/playbooks`).then((r) => (r.ok ? r.json() : { playbooks: [] })).then((d) => { cache = d.playbooks; setList(cache); }).catch(() => setList([]));
  }, []);
  return list;
}

// Playbook slugs to surface on a given solution path.
export const PLAYBOOKS_BY_SOLUTION = Object.fromEntries(Object.entries(COPY.solution.playbooks).map(([k, v]) => [`/mortgages/${k}/`, v]));
